import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckBlank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <rect width={25} height={25} fill="#050033" fillOpacity={0.2} rx={5} />
  </svg>
);
export default SvgCheckBlank;
